export const booleanFilterParams = (fieldName, translate) => ({
    key: fieldName,
    values: ['TRUE', 'FALSE'],
    valueFormatter: (param) => translate.instant('BOOLEAN_' + param.value).toString()
});

export const getBooleanValueGetter = (fieldName, translate, accessor) => (params) => {
    const value = accessor ? accessor(params.data) : params.data?.[fieldName];
    if (value !== undefined) {
        return booleanFilterParams(fieldName, translate).valueFormatter({
            value: value.toString().toUpperCase()
        });
    }
    return null;
};